<template>
  <div class="help-center-search-icon__background">
    <i
      class="help-center-search-icon__icon"
      :class="icon"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import HELP_CENTER_TYPES from 'help-center/constants/types'

const props = defineProps({
  result: {
    type: Object,
    required: true
  }
})

const icon = computed(() => {
  if (props.result.type === HELP_CENTER_TYPES.FAQS) {
    return 'fa-kit-duotone fa-faqs'
  } else if (props.result.type === HELP_CENTER_TYPES.DOCS) {
    return 'fa-kit-duotone fa-docs'
  } else if (props.result.type === HELP_CENTER_TYPES.GUIDES) {
    return 'fa-kit-duotone fa-guides'
  } else if (props.result.type === HELP_CENTER_TYPES.UPDATES) {
    return 'fa-kit fa-megaphone-2'
  } else if (props.result.type === HELP_CENTER_TYPES.MODERN_BLOG) {
    return 'fa-kit-duotone fa-blog-3'
  } else {
    return 'fa-kit fa-failed-status'
  }
})
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-search-icon {
  &__background {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 32px;
    height: 32px;
    border-radius: 6px;
    background-color: var(--help-center-icon-bg);
  }

  &__icon {
    @include help-center-icon(20);
    color: var(--help-center-highlight);
    flex: none;
  }
}
</style>
